import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useStateScroll(scrolled, setScrolled);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-background-200/0"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 h-16">
        {/* Brand + H1 (首页 H1 包裹 logo) */}
        <h1 className="flex items-center gap-2.5">
          <a href="#top" className="flex items-center gap-2.5" aria-label="98黑料 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              98
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">黑料</span>
              <span className="text-[10px] font-medium tracking-[0.3em] text-foreground-400">补课 · 避雷 · 时间线</span>
            </span>
          </a>
        </h1>

        {/* 桌面导航 */}
        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2.5 md:flex">
          <button
            type="button"
            className="whitespace-nowrap rounded-full border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-foreground-950 hover:bg-foreground-950 hover:text-background-50"
          >
            投稿爆料
          </button>
          <button
            type="button"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            开始补课
          </button>
        </div>

        {/* 移动端汉堡 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 md:hidden"
        >
          <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`} />
        </button>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-2 flex gap-2.5 border-t border-background-200 pt-3">
              <button
                type="button"
                className="whitespace-nowrap flex-1 rounded-full border border-foreground-300 px-4 py-2 text-sm text-foreground-800"
              >
                投稿爆料
              </button>
              <button
                type="button"
                className="whitespace-nowrap flex-1 rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50"
              >
                开始补课
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

function useStateScroll(value: boolean, set: (v: boolean) => void) {
  useEffect(() => {
    const onScroll = () => {
      const next = window.scrollY > 24;
      if (next !== value) set(next);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [value, set]);
}